import { LayoutGrid, PlusCircle, ShieldCheck, Bot } from 'lucide-react';

export type AssetRegistryView = 'library' | 'add' | 'channel-check' | 'review-queue';

interface AssetRegistrySidebarProps {
  currentView: AssetRegistryView;
  onNavigate: (view: AssetRegistryView) => void;
  queueCount: number;
}

const NAV_ITEMS: { view: AssetRegistryView; label: string; icon: React.ReactNode }[] = [
  { view: 'library',       label: 'Asset Library',  icon: <LayoutGrid size={18} /> },
  { view: 'add',           label: 'Add Asset',       icon: <PlusCircle size={18} /> },
  { view: 'channel-check', label: 'Channel Check',   icon: <ShieldCheck size={18} /> },
  { view: 'review-queue',  label: 'Review Queue',    icon: <Bot size={18} /> },
];

export function AssetRegistrySidebar({ currentView, onNavigate, queueCount }: AssetRegistrySidebarProps) {
  return (
    <>
      <style>{`
        .ar-sidebar { color: #ffffff !important; }
        .ar-sidebar div  { color: #ffffff !important; }
        .ar-sidebar span { color: #ffffff !important; }
        .ar-sidebar p    { color: #ffffff !important; }
        .ar-sidebar button { color: rgba(255,255,255,0.6) !important; border-radius: 8px !important; }
        .ar-sidebar button:hover { color: #ffffff !important; background: rgba(255,255,255,0.08) !important; }
        .ar-sidebar .nav-active { color: #ffffff !important; background: #1B4B8A !important; }
        .ar-sidebar .ar-dim     { color: rgba(255,255,255,0.55) !important; }
        .ar-sidebar .ar-subtle  { color: rgba(255,255,255,0.3) !important; }
        .ar-sidebar .ar-badge   { color: #0f2240 !important; background: #f59e0b !important; }
      `}</style>

      <aside className="ar-sidebar" style={{ width: 220, minHeight: '100%', background: '#0f2240', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>

        {/* Logo */}
        <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: '#1B4B8A', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <LayoutGrid size={18} color="#fff" />
            </div>
            <div>
              {/* <div style={{ fontWeight: 700, fontSize: 14, lineHeight: '1.3' }}>Caryfy</div> */}
              <div className="ar-dim" style={{ fontSize: 11, lineHeight: '1.3' }}>Asset Registry</div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '12px 10px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV_ITEMS.map(({ view, label, icon }) => {
            const isActive = currentView === view;
            const badge = view === 'review-queue' && queueCount > 0 ? queueCount : null;
            return (
              <button
                key={view}
                className={isActive ? 'nav-active' : ''}
                onClick={() => onNavigate(view)}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center', gap: 10,
                  padding: '10px 12px', borderRadius: 8, border: 'none', cursor: 'pointer',
                  background: isActive ? '#1B4B8A' : 'transparent',
                  fontWeight: isActive ? 600 : 400, fontSize: 13,
                  transition: 'all 0.15s',
                }}
              >
                <span style={{ flexShrink: 0, display: 'flex' }}>{icon}</span>
                <span style={{ flex: 1, textAlign: 'left', fontSize: 13 }}>{label}</span>
                {badge && (
                  <span className="ar-badge" style={{ fontSize: 11, fontWeight: 700, padding: '2px 7px', borderRadius: 20, minWidth: 22, textAlign: 'center' }}>
                    {badge}
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        {/* Footer */}
        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div className="ar-subtle" style={{ fontSize: 11 }}>Internal tool — Caryfy AI team</div>
        </div>
      </aside>
    </>
  );
}
